// src/app/page.tsx
"use client";

import { useEffect, useState } from "react";
import { useAppSelector } from "../redux/hooks";
import { selectIsLoggedIn } from "../redux/selectors/profile/userSelectors";

import HomePage from "./(main)/home/page";
import ProfilePage from "../components/profiles/ProfilePage";
import SafariHydrationGuard from "../components/safety/SafariHydrationGuard";

export default function RootPage() {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) return null;

  // ✅ Logged-in users also stay on "/"
  if (isLoggedIn) {
    return <ProfilePage />;
  }

  return (
    <SafariHydrationGuard>
      <HomePage />
    </SafariHydrationGuard>
  );
}
